module.exports = __webpack_public_path__ + "img/icon-hyyy.92c401cf.png";